import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

const personalNameSelector = createSelector(
  get('user.currentUser.first_name'),
  get('user.currentUser.last_name'),
  (firstName, lastName) => {
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }
    return firstName || lastName || '';
  }
);

export default personalNameSelector;
